import { render } from "./JoinOrganization.vue?vue&type=template&id=169a8ce2&scoped=true"
import script from "./JoinOrganization.vue?vue&type=script&lang=js"
export * from "./JoinOrganization.vue?vue&type=script&lang=js"

import "./JoinOrganization.vue?vue&type=style&index=0&id=169a8ce2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-169a8ce2"]])

export default __exports__